export const ICON_MAPPING = {
  cancel: { x: 0, y: 0, width: 24, height: 24, anchorX: 200, mask: false },
  cancelNoAnchor: { x: 0, y: 0, width: 24, height: 24, mask: false },
  confirm: { x: 24, y: 0, width: 24, height: 24, anchorX: -50, mask: false },
  confirmNoAnchor: { x: 24, y: 0, width: 24, height: 24, mask: false },
};
